import React from 'react'
import { usePrismicDocumentsByIDs } from '@prismicio/react'
import { FilterBar } from './FilterBar'
import LoadingScreen from '../../../utils/LoadingScreen'

export const FilterFetch = ({data}) => {
	const slugs = data.results[0]?.data.group_filter.map(group => group.filter_bar.id)

	const [documents, { state }] = usePrismicDocumentsByIDs(slugs)

	if (state !== 'loaded') {
		return <LoadingScreen />
	}

	return <FilterBar data={documents} />
};
